import { GlobalEvents, globalEvents } from "../../../utils/globalevents"
import { wasmModule } from "../wasm/wasmModule"

export interface IIPRData {
  stage: number
  value: any
  actualValue: any
}

export type ReportIPRData = Record<number, IIPRData[]>

class IprModule {
  private isOpen = false
  private stageIndexForShow = 0

  setIPRVisibility(isVisible, stageIndexForShow: number) {
    if (!wasmModule.isFinishedOpencase) return
    this.isOpen = isVisible
    this.stageIndexForShow = stageIndexForShow
    wasmModule.statusController.DisplayArchIPR(
      wasmModule.statusController.GetCurrentDiplayArch(),
      this.isOpen,
      this.stageIndexForShow,
    )
  }
  updateIPRVisibility() {
    if (this.isOpen)
      wasmModule.statusController.DisplayArchIPR(
        wasmModule.statusController.GetCurrentDiplayArch(),
        this.isOpen,
        this.stageIndexForShow,
      )
  }
  getIPRReport(getHisReport: boolean = false): ReportIPRData {
    const iprReport: ReportIPRData = {}

    const newIpr = wasmModule.statusController.GetStagesIPRReport(getHisReport)

    for (let i = 0; i < newIpr.size(); i++) {
      const iprs = newIpr.get(i)
      const toothid = iprs.toothId
      const iprData: IIPRData[] = []

      for (let j = 0; j < iprs.valVec.size(); j++) {
        const ipr = iprs.valVec.get(j)
        const stage = ipr.stepNum
        const value = ipr.value
        const actualValue = ipr.actualValue

        if (
          (!value || Number.parseFloat(value) == 0) &&
          (!actualValue || Number.parseFloat(actualValue) == 0)
        )
          continue

        iprData.push({
          stage,
          value,
          actualValue,
        })
        // console.log("ysss🚀 ~ file: iprModule.ts:44 ~ ipr:", ipr);
      }

      iprReport[toothid] = iprData
    }
    return iprReport
  }

  setActualIPRValue(IPRValuesStr: string): boolean {
    if (!wasmModule.isFinishedOpencase) return false
    return wasmModule.statusController.SetActualIPRValue(IPRValuesStr)
  }

  setIPRMessage(IPRMessage: string): boolean {
    if (!wasmModule.isFinishedOpencase) return false
    return wasmModule.statusController.SetIPRMessage(IPRMessage)
  }

  getIPRMessage(): string {
    if (!wasmModule.isFinishedOpencase) return ""
    return wasmModule.statusController.GetIPRMessage()
  }
}

export const iprModule = new IprModule()

globalEvents.on(GlobalEvents.VIEW_SWITCH_TYPE, (type: string) => {
  console.log("updateIPRVisibility......", type)
  iprModule.updateIPRVisibility()
})
